/**
 * {@link WorkOrderCreationRequestsToolbar} model.
 */
import CostPool from "@/models/server/CostPool";

export default class WorkOrderCreationRequestsToolbarModel {

    public from: Date | null = null;

    public to: Date | null = null;
    
    public search: string | null = null;

    public showDeleted: boolean = false;

    public costPoolsFilter: CostPool[] = [];
}